var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("AdminOrdersSubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isExternal: true,
      forceTab: "creditNote"
    }
  }), _c("section", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_c("h1", [_vm._v(_vm._s("Credit Note"))]), _c("creditNote", {
    attrs: {
      id: _vm.$route.params.id,
      loggedUserData: _vm.loggedUserData
    }
  })], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };